// Herkunft: https://blocks.tremor.so/blocks/empty-states
// Handlungsorientierter Leerzustand — nicht „Keine Daten“.
//
// Feinschliff, abgestimmt: Der gestrichelte Rahmen ist weg. Er bedeutet in
// dieser Oberfläche sonst nichts — außer hier stand er nirgends, und wo eine
// Form nur einmal vorkommt, liest man sie als Fehler und nicht als Absicht.
// An seine Stelle tritt eine vertiefte Fläche: Die Karten steigen aus der
// Seite heraus, der Leerzustand sinkt hinein. Das ist dieselbe Aussage in der
// Sprache, die der Rest der Oberfläche schon spricht.

import type { ReactNode } from "react";
import { Button } from "@/components/Button";
import { RabeAvatar } from "@/components/RabeAvatar";

export function Leerzustand({
  titel,
  hinweis,
  aktionLabel,
  onAktion,
  aktion,
  bild,
}: {
  titel: string;
  hinweis: string;
  aktionLabel?: string;
  onAktion?: () => void;
  aktion?: ReactNode;
  /**
   * Ein eigenes Bild statt des allgemeinen Avatars.
   *
   * Für Zustände, die eine bestimmte Sache meinen — etwa „noch nicht mit
   * GitLab verknüpft". Ein Bild, das die Lage benennt, sagt mehr als der
   * wartende Rabe, der überall gleich aussieht. Bleibt der Slot leer, ändert
   * sich nichts.
   */
  bild?: ReactNode;
}) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-xl bg-gray-100/70 px-6 py-14 text-center dark:bg-gray-900/40"
      data-testid="leerzustand"
    >
      {/*
        Der Rabe wartet mit. Ein Leerzustand ist die einzige Fläche, auf der
        das Zeichen des Hauses nichts verdrängt — hier steht ohnehin nichts.
        Er ist bewusst klein und unbunt gehalten: Er soll die Stelle besetzen,
        an der sonst ein Loch wäre, und nicht von der Schaltfläche darunter
        ablenken. Die Ruhephase seiner Bewegung sorgt dafür, dass er
        neunzig Prozent der Zeit einfach dasitzt.
      */}
      {bild ?? <RabeAvatar groesse={48} className="mb-4" />}
      <h2 className="text-balance text-base font-semibold tracking-titel text-gray-900 dark:text-gray-50">
        {titel}
      </h2>
      <p className="mt-1.5 max-w-sm text-pretty text-sm text-gray-600 dark:text-gray-400">
        {hinweis}
      </p>
      {aktion
        ? <div className="mt-5">{aktion}</div>
        : aktionLabel && onAktion
          ? (
            <Button className="mt-5" onClick={onAktion}>
              {aktionLabel}
            </Button>
          )
          : null}
    </div>
  );
}
